import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const DatabaseDownstreamDatasourcesFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamDatasourcesFilteredByTableQuery(
  $tableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: PublishedDatasourceSortOrder!
) {
  tables(filter: { id: $tableId }) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
